import React, { useEffect, useState } from "react";
import SearchImg from "../../../assets/user/images/search1.svg";
import UserImg from "../../../assets/user/images/user.png";
import uploadImage from "../../../assets/admin/images/uploadImage.svg";
import RightArrow from "../../../assets/user/images/right-arow.png";
import DatePicker from "react-datepicker";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import Loader from "../../../layouts/loader/Loader";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../utlis/staff/routes.utlis";
import { api } from "../../../utlis/staff/api.utlis";
import toast from "react-hot-toast";
import ApiService from "../../../core/services/ApiService";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { MultipleFile, SingleFile } from "../../../utlis/common.utlis";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import moment from "moment";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { encode } from "base-64";

const Dashboard = () => {
  const navigate = useNavigate();
  const [dashboard, setDashboard] = useState();
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [unfollow, setUnfollow] = useState({
    status: false,
    id: null,
  });
  const [creation, setCreate] = useState({
    status: false,
  });

  const initialValues = {
    title: "",
    description: "",
    files: "",
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required!"),
    description: Yup.string().required("Description is required!"),
    files: Yup.array()
      .of(
        Yup.mixed()
          .required("Community image is required")
          .test("fileSize", "File size is too large", (file) => {
            return file && file.size <= MultipleFile * 1024 * 1024;
          })
          .test("fileType", "Unsupported file type", (file) => {
            return (
              file &&
              ["image/jpeg", "image/png", "image/jpg"].includes(file.type)
            );
          })
      )
      .required("At least one image is required")
      .min(1, "At least one image is required")
      .max(3, "You can upload a maximum of 3 images"),
  });

  const createCommunity = async (formValue) => {
    setLoading(true);
    let form = new FormData();
    form.append("title", formValue.title);
    form.append("description", formValue.description);
    formValue.files.forEach((image) => {
      form.append("cover_image", image);
    });
    const response = await ApiService.postAPIWithAccessTokenMultiPart(
      api.communityAdd,
      form
    );
    setCreate({ status: false });
    document.getElementById("add-community-form").reset();
    if (response.data.status) {
      toast.success(response.data.message);
      getDashboardData(api.communityDashboard);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const getDashboardData = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("community dashboard => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setDashboard(response.data.data);
    } else {
      setDashboard();
    }
    setLoading(false);
  };

  const followCommunity = async (id) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(
      api.communityFollow + `${id}`
    );
    if (response.data.status) {
      toast.success(response.data.message);
      getDashboardData(api.communityDashboard);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const unFollowCommunity = async () => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.communityUnFollow + `${unfollow.id}`
    );
    setUnfollow({
      status: false,
      id: null,
    });
    if (response.data.status) {
      toast.success(response.data.message);
      getDashboardData(api.communityDashboard);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const handleFilter = (e, date = null) => {
    e.persist();
    let name = "";
    if (e.target.name === "name") name = e.target.value;
    if (date != null && date != undefined && date != "")
      date = moment(date).format("yyyy-MM-DD");
    else date = "";
    getDashboardData(api.communityDashboard + `?search=${name}&date=${date}`);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getDashboardData(api.communityDashboard);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="care-community-section">
          <div className="community-title-header">
            <h2 className="heading-title">Care community</h2>
            <div className="search-filter wd50">
              <div className="row g-2">
                <div className="col-md-4">
                  <Link className="btn-gr wd100" to={routes.communityFollowing}>
                    My Following
                  </Link>
                </div>
                <div className="col-md-4">
                  <Link
                    className="btn-bl wd100"
                    to=""
                    onClick={(e) => {
                      e.preventDefault();
                      setCreate({ status: true });
                    }}
                  >
                    Create New
                  </Link>
                </div>
                <div className="col-md-4">
                  <Link className="btn-gr wd100" to={routes.communityList}>
                    My Community
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="community-title-header">
            <h2 className="heading-title">My Community</h2>
            <div className="search-filter wd10">
              <div className="row g-2 d-flex justify-content-between align-items-center">
                <div className="col-md-12">
                  <Link className="btn-bl wd100" to={routes.communityList}>
                    View All
                  </Link>
                </div>

                {/* <div className="col-md-8">
                  <div className="form-group mb-0">
                    <div className="search-form-group">
                      <input
                        type="text"
                        onChange={(e) => handleFilter(e)}
                        name="name"
                        className="form-control"
                        placeholder="Search By Community Name"
                      />
                      <span className="search-icon">
                        <img src={SearchImg} />
                      </span>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="row mb-3">
            {dashboard?.myCommunityList?.length !== 0 &&
            dashboard?.myCommunityList !== "" &&
            dashboard?.myCommunityList !== null &&
            dashboard?.myCommunityList !== undefined ? (
              dashboard?.myCommunityList?.map((ele, indx) => {
                return (
                  <div key={indx} className="col-md-4">
                    <div className="community-card">
                      <div className="community-head">
                        <div className="community-head-media">
                          {ele.profile_image === null ||
                          ele.profile_image === "" ||
                          ele.profile_image === undefined ? (
                            <img src={NoImage} alt="" />
                          ) : (
                            <img src={ele.profile_image} alt="" />
                          )}
                        </div>
                        <div className="community-head-content text-capitalize">
                          <h4>{ele.fullname ?? "NA"}</h4>
                        </div>
                        <div className="community-head-action">
                          <Link
                            className="view-font-btn"
                            style={{ width: "31px", height: "31px" }}
                            to=""
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(routes.communityInfo, {
                                state: {
                                  id: encode(ele.id),
                                },
                              });
                            }}
                          >
                            <img width={19} src={RightArrow} />
                          </Link>
                        </div>
                      </div>
                      <div className="community-image">
                        <CarouselProvider
                          id="Main-Slider"
                          naturalSlideWidth={100}
                          naturalSlideHeight={50}
                          totalSlides={
                            ele.cover_image.length !== 0
                              ? ele.cover_image.length
                              : 1
                          }
                          isPlaying={true}
                        >
                          <Slider>
                            {ele.cover_image.length !== 0 ||
                            ele.cover_image !== null ||
                            ele.cover_image !== "" ||
                            ele.cover_image !== undefined ? (
                              ele.cover_image.map((ele, indx) => {
                                return (
                                  <Slide key={indx} index={indx}>
                                    <div className="item">
                                      <div className="Main-Slider-media">
                                        <img src={ele.image} alt="Cover" />
                                      </div>
                                    </div>
                                  </Slide>
                                );
                              })
                            ) : (
                              <img src={NoImage} alt="" />
                            )}
                          </Slider>
                        </CarouselProvider>
                      </div>
                      <div className="community-content">
                        <h3 className="text-capitalize">{ele.title ?? "NA"}</h3>
                        <p>{ele.description ?? "NA"}</p>
                        <div className="community-folllow-user">
                          <div className="community-folllow-media">
                            {ele?.last_following_member_images?.length !== 0 ? (
                              ele?.last_following_member_images?.map(
                                (element, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className={
                                        "folllow-user-image image" +
                                        `${index + 1}`
                                      }
                                    >
                                      {element === null ||
                                      element === "" ||
                                      element === undefined ? (
                                        <img src={NoImage} alt="No profile" />
                                      ) : (
                                        <img
                                          src={element}
                                          alt={`Member ${index + 1}`}
                                        />
                                      )}
                                    </div>
                                  );
                                }
                              )
                            ) : (
                              <div className="folllow-user-image image1">
                                <img src={NoImage} alt="No profile" />
                              </div>
                            )}
                          </div>
                          <div className="folllow-user-text">
                            {ele.member_count ?? 0} Followers
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "5% 0",
                }}
              >
                <img width={300} src={NoData} alt="" />
              </div>
            )}
          </div>
        </div>

        <div className="care-community-section">
          <div className="community-title-header">
            <h2 className="heading-title">Suggested Community</h2>
            <div className="search-filter wd10">
              <div className="row g-2 d-flex justify-content-between align-items-center">
                <div className="col-md-12">
                  <Link className="btn-bl wd100" to={routes.communitySuggested}>
                    View All
                  </Link>
                </div>

                {/* <div className="col-md-8">
                  <div className="form-group mb-0">
                    <div className="search-form-group">
                      <input
                        type="text"
                        onChange={(e) => handleFilter(e)}
                        name="name"
                        className="form-control"
                        placeholder="Search By Community Name"
                      />
                      <span className="search-icon">
                        <img src={SearchImg} />
                      </span>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="row">
            {dashboard?.communityList?.length !== 0 &&
            dashboard?.communityList !== "" &&
            dashboard?.communityList !== null &&
            dashboard?.communityList !== undefined ? (
              dashboard?.communityList?.map((ele, indx) => {
                return (
                  <div key={indx} className="col-md-4">
                    <div className="community-card">
                      <div className="community-head">
                        <div className="community-head-media">
                          {ele.profile_image === null ||
                          ele.profile_image === "" ||
                          ele.profile_image === undefined ? (
                            <img src={NoImage} alt="" />
                          ) : (
                            <img src={ele.profile_image} alt="" />
                          )}
                        </div>
                        <div className="community-head-content text-capitalize">
                          <h4>{ele.fullname ?? "NA"}</h4>
                        </div>
                        <div className="community-head-action">
                          {ele.is_following == "false" ? (
                            <Link
                              className="Follow-btn mx-1"
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                followCommunity(ele.id);
                              }}
                            >
                              Follow
                            </Link>
                          ) : (
                            <Link
                              className="UnFollow-btn mx-1"
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                setUnfollow({
                                  status: true,
                                  id: ele.id,
                                });
                              }}
                            >
                              Unfollow
                            </Link>
                          )}
                          <Link
                            className="view-font-btn"
                            style={{ width: "31px", height: "31px" }}
                            to=""
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(routes.communityInfo, {
                                state: {
                                  id: encode(ele.id),
                                },
                              });
                            }}
                          >
                            <img width={19} src={RightArrow} />
                          </Link>
                        </div>
                      </div>
                      <div className="community-image">
                        <CarouselProvider
                          id="Main-Slider"
                          naturalSlideWidth={100}
                          naturalSlideHeight={50}
                          totalSlides={
                            ele.cover_image.length !== 0
                              ? ele.cover_image.length
                              : 1
                          }
                          isPlaying={true}
                        >
                          <Slider>
                            {ele.cover_image.length !== 0 ||
                            ele.cover_image !== null ||
                            ele.cover_image !== "" ||
                            ele.cover_image !== undefined ? (
                              ele.cover_image.map((ele, indx) => {
                                return (
                                  <Slide key={indx} index={indx}>
                                    <div className="item">
                                      <div className="Main-Slider-media">
                                        <img src={ele.image} alt="Cover" />
                                      </div>
                                    </div>
                                  </Slide>
                                );
                              })
                            ) : (
                              <img src={NoImage} alt="" />
                            )}
                          </Slider>
                        </CarouselProvider>
                      </div>
                      <div className="community-content">
                        <h3 className="text-capitalize">{ele.title ?? "NA"}</h3>
                        <p>{ele.description ?? "NA"}</p>
                        <div className="community-folllow-user">
                          <div className="community-folllow-media">
                            {ele?.last_following_member_images?.length !== 0 ? (
                              ele?.last_following_member_images?.map(
                                (element, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className={
                                        "folllow-user-image image" +
                                        `${index + 1}`
                                      }
                                    >
                                      {element === null ||
                                      element === "" ||
                                      element === undefined ? (
                                        <img src={NoImage} alt="No profile" />
                                      ) : (
                                        <img
                                          src={element}
                                          alt={`Member ${index + 1}`}
                                        />
                                      )}
                                    </div>
                                  );
                                }
                              )
                            ) : (
                              <div className="folllow-user-image image1">
                                <img src={NoImage} alt="No profile" />
                              </div>
                            )}
                          </div>
                          <div className="folllow-user-text">
                            {ele.member_count ?? 0} Followers
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "5% 0",
                }}
              >
                <img width={300} src={NoData} alt="" />
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal
        show={creation.status}
        onHide={() => {
          setCreate({
            status: false,
          });
        }}
        className="modal-xl"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Create Community</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={createCommunity}
                enableReinitialize
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form" id="add-community-form">
                    <div className="form-group">
                      <h4>Title</h4>
                      <Field
                        type="text"
                        className="form-control todo-list-input"
                        name="title"
                        placeholder="Enter Title"
                      />
                      <ErrorMessage
                        name="title"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group">
                      <h4>
                        Upload Image(s){" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.7rem" }}
                        >
                          (In JPG, JPEG & PNG)
                        </span>
                      </h4>
                      <div className="upload-signature">
                        <Field name="files">
                          {({ field, form }) => (
                            <div>
                              <input
                                type="file"
                                multiple
                                accept="image/jpg, image/jpeg, image/png"
                                className="form-control"
                                onChange={(event) => {
                                  const files = Array.from(
                                    event.currentTarget.files
                                  );
                                  setFieldValue("files", files);
                                }}
                              />
                            </div>
                          )}
                        </Field>
                        <ErrorMessage
                          name="files"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <h4>Description</h4>
                      <Field
                        type="text"
                        as="textarea"
                        className="form-control"
                        name="description"
                        placeholder="Enter Description"
                        style={{ height: "150px" }}
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group text-end">
                      <button
                        type="button"
                        onClick={() => {
                          setCreate({
                            status: false,
                          });
                        }}
                        className="btn btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-gr me-2"
                        data-bs-dismiss="modal"
                      >
                        Add
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={unfollow.status}
        onHide={() => {
          setUnfollow({
            status: false,
            id: null,
          });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Unfollow Community</h5>
                <p className="text-center">
                  Are you sure you want to unfollow this community?
                </p>
              </div>
              <div className="form-group text-center mb-2">
                <button
                  type="button"
                  onClick={() =>
                    setUnfollow({
                      status: false,
                      id: null,
                    })
                  }
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => unFollowCommunity()}
                >
                  Yes! Unfollow
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default Dashboard;
